<!-- 汇率查询 -->
<template>
  <div class="interestRateListHN">
    <sirui-search
      v-if="dictList.length > 10"
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        v-if="dictList.length > 10"
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        column-min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :edit-rules="rules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :max-height="$store.state.app.tableHeight"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { addRules } from './rules.js'; // 校验规则
  import API from '@/api/capitalCenter/moneyDraw';
  import SiruiSearch from '@/components/SiruiSearch';
  import XEUtils from 'xe-utils';
  // import InputNumber from '@/components/form-item/input-number';
  // import SearchTable from '@/components/form-item/search-table';

  export default {
    name: 'interestRateListHN',
    components: {
      SiruiSearch,
      // InputNumber,
      // SearchTable,
    },
    computed: {
      ...mapState({
        dictList: (state) => state.dict.dictList,
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            // 利率类型
            name: this.$t('interestRate.column.interestRateCode'),
            prop: 'interestRateCode',
            type: 'select',
            options: this.interestRateTypeList,
            filterable: true,
          },
          {
            // 客户
            name: '客户',
            prop: 'customerCode',
            type: 'searchTableSpec',
            searchType: 'customer',
            isMultiple: true,
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'interestType',
            title: '周转状态',
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('hn_order_interestType'),
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            field: 'interestEffectiveStartDays',
            title: this.$t('interestRate.column.interestEffectiveStartDays'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestEffectiveStartDays}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestEffectiveStartDays}
                    max={999999999.999999}
                    min={0}
                    precision={0}
                    onInput={(val) => this.chooseTable(val, row, 'interestEffectiveStartDays')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'interestEffectiveEndDays',
            title: this.$t('interestRate.column.interestEffectiveEndDays'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestEffectiveEndDays}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestEffectiveEndDays}
                    max={999999999.999999}
                    min={0}
                    precision={0}
                    onInput={(val) => this.chooseTable(val, row, 'interestEffectiveEndDays')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'orderType',
            title: '订单类型',
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('hn_order_businessType'),
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            // 客户
            field: 'customerCode',
            title: '客户',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.customerName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="customer"
                    isMultiple={true}
                    currentValue={row['customerName']}
                    checkRowKeys={[row['customerCode']]}
                    onInput={(val) => this.chooseTable(val, row, 'customerCode')}
                    extraData={{
                      adminFlag: this.userInfo.adminFlag,
                      requestStatus: 'ZT03',
                      partnerCompanyCode: this.$globalVar.subserver.companyCode,
                      partnerTypes: 'HZHB01',
                    }}
                  ></search-table>,
                ];
              },
            },
          },
          {
            field: 'interestRateCode',
            title: '利率类型',
            editRender: {
              name: 'ElSelect',
              options: this.interestRateTypeList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.interestRateCodeChange },
            },
          },
          {
            field: 'interestRate',
            title: '利率',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestRate}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'interestRate')}
                  ></input-number>,
                ];
              },
            },
          },
        ];
      },
    },
    data() {
      return {
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
        multipleSelection: [],
        query: {
          interestRateCode: null,
          interestRateCodes: [],
          customerCode: null,
        },
        interestRateTypeList: [
          { value: '009', label: '年利率' },
          { value: '010', label: '月利率' },
          { value: '011', label: '日利率' },
        ],
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        rules: addRules,
      };
    },
    mounted() {
      this.query.interestRateCodes = this.interestRateTypeList.map((item) => {
        return item.value;
      });
      this.getData();
      this.getButtonList();
    },
    methods: {
      chooseTable(val, row, prop) {
        if (prop == 'customerCode') {
          if (val && val.length > 0) {
            row.customerName = val[0].partnerZhName;
            row.customerCode = val[0].partnerCode;
          } else {
            row.customerName = row.customerCode = '';
          }
        } else {
          row[prop] = val;
        }
      },
      interestRateCodeChange(val) {
        val.row.interestRateName = val.row.interestRateCode
          ? this.interestRateTypeList.find((item) => item.value == val.row.interestRateCode).label
          : '';
      },
      async getData() {
        this.load = true;
        const [pageNum, pageSize] = [this.page.pageNum, this.page.pageSize];
        console.log(this.query.customerCode);
        if (this.query.customerCode && XEUtils.isObject(this.query.customerCode))
          this.query.customerCode = this.query.customerCode[0]?.partnerCode;
        const params = { ...this.query, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_INTERESTRATE_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          }
        }
      },
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'edit') {
          this.handleEdit();
        } else if (value === 'save') {
          this.handleSave();
        } else if (value == 'del') {
          this.handleDel();
        }
      },
      // 跳转至新增页面
      handleAdd() {
        let path = {
          path: '/moneyDraw/interestRateAddHN',
          name: 'interestRateAddHN',
          meta: {
            keepAlive: true,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 编辑
      handleEdit() {
        let selectRecords = this.$refs.table.getCheckboxRecords();
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            this.$refs.table.setActiveRow(item);
          });
          this.$refs.table.validate(selectRecords).catch((errMap) => errMap); //修改校验
        } else {
          this.$message({
            showClose: true,
            message: this.$t('interestRate.message.select'),
            type: 'error',
          });
        }
      },
      async handleSave() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API.SAVE_INTERESTRATE, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.resetBtnClick();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected');
        }
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            this.del(ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        const params = {
          ids,
        };
        this.$axios.post(API.DELETE_INTERESTRATE, params).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate((valid) => {
            if (valid) {
              let param = {
                list: tableData,
              };
              resolve(param);
            }
          });
        });
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`interestRate.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>
